import axios from "common/configs/axiosConfigs";
import React, { useState } from "react";
import logo from "assets/img/logo.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CompanyDetails = () => {
  const [values, setValues] = useState({});
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post("", {
        action: "registerFirm",
        ...values,
      });
      if (data?.success) {
        const prevAuth = JSON.parse(localStorage.getItem("user-auth"));

        localStorage.setItem(
          "user-auth",
          JSON.stringify({ ...prevAuth, is_register: 1, company_id: data?.data?.company_id })
        );
        navigate("/");
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };
  const handleInput = ({ target: { value, name } }) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <section className="login-section p-0">
      <div className="container">
        <img src={logo} alt="logo" style={{ width: 70, display: "block", margin: "0 auto 20px" }} />
        <div className="card login-box mx-auto">
          <h3 className="text-center">Company Name</h3>
          <p className="text-muted text-center">Enter your company name to get proceed</p>
          <form onSubmit={handleSubmit}>
            <div className="row gy-3">
              <div className="col-12">
                <label>
                  <input
                    type="text"
                    name="firmName"
                    onChange={handleInput}
                    className="form-control"
                    placeholder="Company name"
                    required
                  />
                </label>
              </div>
            </div>

            <button type="submit" className="btn btn-primary mt-3 w-100">
              Finish
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default CompanyDetails;
